import Vue from 'vue'

const strategyEndpoints = {
  local1: { url: '/api/auth/login', method: 'post' },
  local2: { url: '/api/auth/smslogin', method: 'post' },
  local3: { url: '/api/auth/login', method: 'post' }
}

export function createAuth({ axios, cookies, router, store }) {
  const state = Vue.observable({
    loggedIn: false,
    user: null,
    strategy: cookies.get('auth.strategy') || 'local1'
  })

  const auth = {
    get loggedIn() {
      return state.loggedIn
    },
    get user() {
      return state.user
    },
    get strategy() {
      return state.strategy
    },
    async init() {
      const strategy = cookies.get('auth.strategy')
      const token = strategy && cookies.get(`auth._token.${strategy}`)
      if (!strategy || !token) return
      state.strategy = strategy
      state.loggedIn = true
      try {
        await auth.fetchUser()
      } catch (e) {
        auth.reset()
      }
    },
    reset() {
      const strategy = state.strategy || cookies.get('auth.strategy')
      if (strategy) {
        cookies.remove(`auth._token.${strategy}`)
      }
      cookies.remove('auth.strategy')
      state.loggedIn = false
      state.user = null
    },
    setUserToken(token, strategy = state.strategy || 'local1') {
      state.strategy = strategy
      cookies.set('auth.strategy', strategy, { path: '/', maxAge: 60 * 60 * 24 * 7 })
      cookies.set(`auth._token.${strategy}`, token.startsWith('Bearer ') ? token : `Bearer ${token}`, { path: '/', maxAge: 60 * 60 * 24 * 7 })
      state.loggedIn = true
    },
    setUser(user) {
      state.user = user
      state.loggedIn = !!user
    },
    async fetchUser() {
      const user = await axios.get('/api/user')
      auth.setUser(user)
      return user
    },
    async loginWith(strategy, payload = {}) {
      const endpoint = strategyEndpoints[strategy]
      if (!endpoint) {
        return Promise.reject('Unsupported login strategy')
      }
      const config = payload.params ? { params: payload.params } : undefined
      const response = await axios[endpoint.method](endpoint.url, payload.data || {}, config)
      const token = response.token || (response.data && response.data.token) || (response.result && response.result.token)
      const user = response.user || (response.data && response.data.user) || (response.result && response.result.user)

      if (!token) {
        return Promise.reject('Login token missing')
      }

      auth.setUserToken(token, strategy)
      if (user) {
        auth.setUser(user)
      } else {
        await auth.fetchUser()
      }
      return response
    },
    async logout() {
      try {
        await axios.post('/api/logout')
      } finally {
        auth.reset()
        store.commit('cartNum', 0)
        router.push('/login')
      }
    }
  }

  return auth
}
